module.exports = __webpack_public_path__ + "static/media/chiller.d4177d2f.png";